import { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
//---------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import Resize from "src/components/common/resize";
import UserInfo from "src/components/common/userInfo";
import {
    weeknum, 
    weekDays, 
    getDatefromWeekNum0, 
    getDateEndFromWeekNum, 
    myAxios, 
    exclusiveOutisdeKeys, 
    MyFormData, 
    pmEmails, 
    MyDate, 
    isDevMode, 
    getTimeStamp, 
    outsideDailydefaultEmptyData, 
    standbyWeeks as weeks, 
    boolAndReducer,
    appTitle
} from "src/components/common/functions";
import Footer from "src/components/common/frame/footer";
import magnifierImg from "src/img/magnifier.png";
import Export from "./export";
//--------------------------------------------------------------------------------------------
export default function AllCheckIn({ tabTitle }){
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const divisions = useMyStore((state) => state.outsideserviceLocatorDivisions);
    const setDivisions = useMyStore((state) => state.setOutsideserviceLocatorDivisions);
    const forms = useMyStore((state) => state.outsideserviceDailyForms);
    const setForms = useMyStore((state) => state.setOutsideserviceDailyForms);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? "");
    const path2 = decodeURIComponent(path.split("/")[2] ?? "");
    const path3 = decodeURIComponent(path.split("/")[3] ?? "");
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Forms": forms.updatedAt === null?getTimeStamp():forms.updatedAt, 
        "Divisions": divisions.updatedAt === null?getTimeStamp():divisions.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [week, setWeek] = useState(() => !weeks.includes(path2)?weeknum((new MyDate()).s()):path2);
    const [weekDay, setWeekDay] = useState(() => !isNaN(path3) && window.Number.parseInt(path3) <= 6 && window.Number.parseInt(path3) >= 0?window.Number.parseInt(path3):0);
    const [category, setCategory] = useState("");
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(50);
    //--------------------------------------------------------------------------------------------
    const curForms = useMemo(() => forms[week] ?? [], [forms, week]);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredForms = useMemo(() => curForms.filter(form => 
        !pmEmails.includes(form.email) && 
        (week && (weekDay > -1)?(
        (category?form.outside === category:true) &&
        (getDatefromWeekNum0(week, weekDay) > new Date(form.hireDate.replace(/-/g, "/"))) &&
        (form.quitDate?(getDatefromWeekNum0(week, weekDay) <= new Date(form.quitDate.replace(/-/g, "/"))):true)
        ):true) && 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(curForms)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    ), [curForms, week, weekDay, category, filterWords]);
    const currentForms = filteredForms.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredForms.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            if(isDevMode) console.log("useEffect side");
            const formData = new MyFormData();
            //-------------------------------------------------
            setShowLoader(true);
            const resDivision = await myAxios("outside/daily/readDivisions.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoader(false);
            if(!resDivision) return;
            //-------------------------------------------------
            setDivisions(resDivision.data, updateDateTime["Divisions"]);
        }
        if(updateDateTime["Divisions"] !== divisions.updatedAt) getData();
        return () => {
            isMounted = false;
            controller.abort();
            setShowLoader(false);
        }
    },[updateDateTime, divisions.updatedAt, setDivisions, setShowLoader])
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            if(isDevMode) console.log("useEffect main");
            const formData = new MyFormData();
            formData.append("week", week);
            //-------------------------------------------------
            setShowLoading(true);
            const resAllDay = await myAxios("outside/daily/allDaily.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resAllDay) return;
            //-------------------------------------------------
            const ordered = resAllDay.data.map(
                personData => Object.fromEntries(
                    Object.entries(personData).map(
                    ([key, value]) => !exclusiveOutisdeKeys.includes(key)?
                    [
                        key, 
                        JSON.parse(
                            value || 
                            outsideDailydefaultEmptyData
                        )
                    ]:
                    [key, value]
                    )
                )
            );
            setForms(week, ordered, updateDateTime["Forms"]);
            history.replace(`/${path1}/${week}/${weekDay}`);
            //----------------------------
        }
        if(!forms[week] || (updateDateTime["Forms"] !== forms.updatedAt)) getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[updateDateTime, week, forms, history, path1, setForms, weekDay])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    All Check-In
                    <span
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                
                {weeks.length?
                <>
                <span className = "d-flex align-items-center">
                   <label htmlFor = "week" className = "mb-0">Week:</label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-2"
                        value = {week}
                        onChange = {e => {
                            setWeek(e.currentTarget.value);
                            setCurrentPage(1);
                            history.replace(`/${path1}/${e.currentTarget.value}`);                   
                        }}
                    >
                        {weeks.map((k, key) => <option key = {key} value = {k}>{getDateEndFromWeekNum(k)}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "day" className = "mb-0">Day:</label>
                    <select
                        id = "day"
                        className = "form-control w-auto ml-2"
                        value = {weekDay}
                        onChange = {e => {
                            setWeekDay(window.Number.parseInt(e.currentTarget.value));
                            setCurrentPage(1);
                            history.replace(`/${path1}/${week}/${e.currentTarget.value}`);                   
                        }}
                    >
                        {weekDays.map((k, key) => <option key = {key} value = {key}>{k}</option>)}
                    </select>
                </span>
                </>
                :<></>}
                <span className = "d-flex align-items-center">
                    <label htmlFor = "category" className = "mb-0">Category:</label>
                    <select
                        id = "category"
                        className = "form-control w-auto ml-2"
                        value = {category}
                        onChange = {e => {
                            setCategory(e.currentTarget.value);
                            setCurrentPage(1);               
                        }}
                    >
                        <option value = "">All</option>
                        <option value = "locator">Mark and Locator</option>
                        <option value = "qew">QEW</option>
                        <option value = "standby">Standby</option>
                    </select>
                </span>
                {filteredForms.length?
                <Export
                    filteredForms = {filteredForms}
                    week = {week}
                    weekDay = {weekDay}
                />
                :<></>}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filteredForms.length?<div className = "cssLoading">Empty</div>:
                <div className = "overflow-visible">
                    <table className = "table text-center tableAllBorder">
                        <thead>
                            <tr className = "stickyHeader">
                                <th>Name</th>
                                <th>Unlock</th>
                                <th>Morning</th>
                                <th>Afternoon</th>
                                <th>OT</th>
                                <th>End Time</th>
                            </tr>
                            </thead>
                            <tbody>
                                {currentForms.map((form, formIndex) => 
                                <tr id = {form.email} key = {formIndex} className = "pointer">
                                    <th>
                                        <UserInfo 
                                            name = {form.userName}
                                            email = {form.email}
                                        />
                                    </th>
                                    {week?
                                    <>
                                    <th>
                                        <span className = {`m-1 btn btn-${form[week].form[weekDay].unlock?"primary":"info"}`} onClick = {async() => {
                                            const formData = new MyFormData();
                                            formData.append("userEmail", form.email);
                                            formData.append("wk", week);
                                            formData.append("wkDay", weekDay);
                                            formData.append("unlock", !form[week].form[weekDay].unlock?"yes":"no");
                                            //-------------------------------------------------
                                            setShowLoader(true);
                                            const res = await myAxios("outside/daily/setDailyUnlock.php", formData);
                                            setShowLoader(false);
                                            if(!res) return;
                                            //-------------------------------------------------
                                            setForms(week, curForms.map(thisForm => thisForm.email === form.email?{
                                                ...thisForm, [week]: {...form[week], form: form[week].form.map((ff, ffi) => ffi === weekDay?{...ff, 
                                                unlock: !form[week].form[weekDay].unlock
                                                }:ff)}
                                            }:thisForm))
                                        }}>
                                            Set {form[week].form[weekDay].unlock?
                                            "Lock"
                                            :
                                            "Unlock"
                                            }
                                        </span>
                                    </th>
                                    <th style = {{color: form[week].form[weekDay].morning?"green":"red"}}>
                                        {form[week].form[weekDay].morning?"Yes":"No"}
                                    </th>
                                    <th style = {{color: form[week].form[weekDay].afternoon?"green":"red"}}>
                                        {form[week].form[weekDay].afternoon?"Yes":"No"}
                                    </th>
                                    <th>
                                        {form[week].form[weekDay].doOT}
                                    </th>
                                    <th>
                                        {
                                        form[week].form[weekDay].otDate && form[week].form[weekDay].otTime?
                                        form[week].form[weekDay].otDate + " " + form[week].form[weekDay].otTime
                                        :
                                        ""
                                        }
                                    </th>
                                    </>
                                    :
                                    <></>
                                    }
                                </tr>
                                )}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredForms.length?
                <Footer
                    length = {filteredForms.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}